import { createSelector } from 'reselect';

const readingIds = state => state.deviceVerificationReadings.ids;
const readingModels = state => state.deviceVerificationReadings.models;

// the API's stable order: created_at, id breaking the ties
const byAge = (a, b) => a.created_at - b.created_at || a.id.localeCompare(b.id);

export const selectReadingsByVerification = verificationId => createSelector(
    [readingIds, readingModels],
    (ids, models) => ids
        .map(id => models[id])
        .filter(reading => reading.device_verification_id === verificationId)
        .sort(byAge)
);

export const selectReadingsGroupedByVerification = createSelector(
    [readingIds, readingModels],
    (ids, models) => {
        const groups = {};
        ids.forEach(id => {
            const reading = models[id];
            (groups[reading.device_verification_id] ||= []).push(reading);
        });
        Object.values(groups).forEach(group => group.sort(byAge));
        return groups;
    }
);
